import ExpandableList from "./ExpandableList";

export default ExpandableList;
